var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"contents-container"}},[_c('MainCard'),_c('div',{staticClass:"body-without-main-card"},[_c('Cards'),_c('Services'),_c('EventGallery')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }